import { IAppUserAuto } from "../../../interfaces";


class AppUserAutoMapper {
    toPersistence(domainAppUserAuto: IAppUserAuto): any {
        return {
            id: domainAppUserAuto.id,
            name: domainAppUserAuto.name,
            cpfCnpj: domainAppUserAuto.cpfCnpj,
            ticketsAuto: domainAppUserAuto.ticketsAuto,
            taxesAuto: domainAppUserAuto.taxesAuto,
            totalTicket: domainAppUserAuto.totalTicket,
            created_at: domainAppUserAuto.created_at,
        }
    }

    toDomain(persistenceAppUserAuto: any): IAppUserAuto {
        return {
            id: persistenceAppUserAuto.id,
            name: persistenceAppUserAuto.name,
            cpfCnpj: persistenceAppUserAuto.cpfCnpj,
            ticketsAuto: persistenceAppUserAuto.ticketsAuto,
            taxesAuto: persistenceAppUserAuto.taxesAuto,
            appUserId: persistenceAppUserAuto.appUserId,
            totalTicket: persistenceAppUserAuto.totalTicket,
            created_at: persistenceAppUserAuto.createdAt,
            updated_at: persistenceAppUserAuto.updatedAt,
        }
    }
}

// eslint-disable-next-line import/no-anonymous-default-export
export default new AppUserAutoMapper();
